import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { Dropdown, TextField } from '@carsys/form'
import { TicketContactPreference } from '@cbgms/api'
import { useTicketFormContext } from '@cbgms/components/src/support-request/context/TicketFormContext'

export const ContactPreferenceFields: React.FC<{}> = () => {
  const { t } = useTranslation()
  const { contactPreference } = useTicketFormContext()
  const showPhoneField = useMemo(() => contactPreference === TicketContactPreference.PhonecallPreference, [contactPreference])
  const showEmailField = useMemo(() => contactPreference === TicketContactPreference.EmailPreference, [contactPreference])

  const options = [
    { text: t('Contact.contact_preference.phone'), value: TicketContactPreference.PhonecallPreference },
    { text: t('Contact.contact_preference.email'), value: TicketContactPreference.EmailPreference }
  ]
  return (
    <Grid container direction='column' spacing={1.5}>
      <Grid item>
        <Typography variant='body1' align='left' gutterBottom>
          {t('Contact.ticket_contract_preference')}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container direction='row' spacing={1}>
          <Grid item xs={6}>
            <Dropdown label={t('Contact.ticket_contract_preference')} name='CallbackDetails.ContactPreference' options={options} />
          </Grid>
          {showPhoneField && (
            <Grid item xs={6}>
              <TextField label={t('Contact.contact_phone_number')} required name='CallbackDetails.PhoneNumber' />
            </Grid>
          )}
          {showEmailField && (
            <Grid item xs={6}>
              <TextField label={t('Contact.contact_email_address')} required name='CallbackDetails.EmailAddress' />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
